import { render, staticRenderFns } from "./BlogAcfBlocks.vue?vue&type=template&id=4b3898ab&"
import script from "./BlogAcfBlocks.vue?vue&type=script&lang=ts&"
export * from "./BlogAcfBlocks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports